import { Component, OnInit } from '@angular/core';
import { Certificate_Asli_Interface } from 'src/app/Interface/Certificate_Asli_Interface';
import { Certificate_Interface } from 'src/app/Interface/Certificate_Interface';
import { CertificateService } from 'src/app/Service/Certificate/Certificate.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-CertificateAsli',
  templateUrl: './CertificateAsli.component.html',
  styleUrls: ['./CertificateAsli.component.scss']
})
export class CertificateAsliComponent implements OnInit {

  Token:String=""
  page:number=0
  Procssing:boolean=false
  DataList_Certificate:Array<Certificate_Asli_Interface>=[]
  BaseUrl=environment.Print_URL+"QRCodeCertificate/"

  Customer_Filter_List:string=""

  constructor(
    private Certificate_Service:CertificateService,
    private Nav_Service:NavService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,12).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

  }

  ReadData_Certificate(){
    this.Procssing=true
    this.Certificate_Service.GetAsli(this.Token).subscribe(
      data=>{
        this.DataList_Certificate=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  exportexcel(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "DaroCertificate.xlsx");

  }

}
